export const verbiage = {
  addPayment: 'Add Payment Method',
  noPaymentMethod: 'No payment method added yet',
  payWith: 'Pay With',
  noPaymentMethodsError: 'You must add a verified payment method before making a payment.',
  pageTitle: 'Payment Method',
};
